import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-thin-right",
  "use": "icon-arrow-thin-right-usage",
  "viewBox": "0 0 227.096 227.096",
  "content": "<symbol viewBox=\"0 0 227.096 227.096\" id=\"icon-arrow-thin-right\">\r\n<g>\r\n\t<g>\r\n\t\t<polygon style=\"fill:#010002;\" points=\"152.835,39.285 146.933,45.183 211.113,109.373 0,109.373 0,117.723 211.124,117.723 \r\n\t\t\t146.933,181.902 152.835,187.811 227.096,113.55 \t\t\" />\r\n\t</g>\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrow-thin-right.svg
// module id = eHir
// module chunks = 107